module.exports = __webpack_public_path__ + "img/ardoise_verte.89930927.jpg";